<script>
import Modal from "@/components/_Shared/Modal/Index";
import Title from "@/components/_Shared/Title";
import Tip from "@/components/_base/Tip";

import OrderCard from "../../../Order/Components/Card/Index";

export default {
  components: {
    Modal,
    Title,
    Tip,
    OrderCard
  },

  props: {
    orders: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <Title title="Limpezas futuras" />
    </template>

    <template slot="body">
      <div>
        <OrderCard
          v-for="order in orders"
          :key="order.id"
          :payable="order"
        />
      </div>
    </template>

    <template slot="footer">
      <Tip>Selecione uma limpeza para ver mais informações sobre ela</Tip>

      <button
        class="btn bg-purple"
        @click="$emit('close')"
      >
        <span>Voltar</span>
      </button>
    </template>
  </Modal>
</template>



// WEBPACK FOOTER //
// src/components/Dashboard/components/Payables/ConfirmedPayablesList.vue